import { createFailure, createRequest, createSuccess } from 'ducks/helpers';
import constants from './constants';

export const tsByClientRequest = createRequest(constants.tsByClient);
export const tsByClientSuccess = createSuccess(constants.tsByClient);
export const tsByClientFailure = createFailure(constants.tsByClient);

export const requestTsByClient = tsByClientRequest;
